import React, { useEffect, useState } from "react";
import MainComponent from "../../../components/ui_comps/MainComponent";
import CustomTimePicker from "../../../components/main_comps/custom_time_picker";
import { showHideFilterModalReducer } from "../../../../data/redux/slice/globalFiltersSlice";
import { useDispatch, useSelector } from "react-redux";
import CustomDatePicker from "../../../components/main_comps/custom_date_picker";
import CustomSelect from "../../../components/main_comps/custom_select";
import { CustomButton } from "../../../components/main_comps/custom_button";
import {
  colorDarkBlue,
  colorWhite,
} from "../../../../utility/constants/colorManager";
import {
  modifierClientData,
  modififyDropdownServiceNameList,
} from "../../../../services/fetchDropdownListData";
import { STATUS_CODE_200 } from "../../../../utility/constants/valueConstants";
import { ApiRequestGet } from "../../../../data/network/services/ApiRequestGet";
import CustomModal from "../../../components/main_comps/custom_modal";
import CustomModalForConfirmation from "../../../components/ui_comps/CustomModalForConfirmation";
import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";
import { CustomInput } from "../../../components/main_comps/custom_input/CustomInput";
import { API_ENDPOINT } from "../../../../data/network/services/ApiEndpoint";
import { ApiGetServiceWrapper } from "../../../../data/network/wrapperService";
import { useSnackbar } from "notistack";
import moment from "moment";
import CheckBoxInput from "../../../components/ui_comps/CheckBoxInput";
import { TimerClock } from "../../../../utility/constants/assetsManager";
import { useNavigate } from "react-router";

const ClientSettlementIndex = () => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedClient, setSelectedClient] = useState("");
  const [selectedServiceProvider, setSelectedServiceProvider] = useState("");
  const [payinServiceList, setPayinServiceList] = useState([]);
  const [openTimePickerModal, setOpenTimePickerModal] = useState(false);
  const [payinClientList, setPayinClientList] = useState([]);
  const [voucherClientList, setVoucherClientList] = useState([]);
  const [actualAmount, setActualAmount] = useState("");
  const [transferAmount, setTransferAmount] = useState("");
  const [comission, setComission] = useState("");
  const [comissionGST, setComissionGST] = useState("");
  const [bankUTR, setBankUTR] = useState("");
  const [rollbackReserves, setRollbackReserves] = useState("");
  const [hours, setHours] = useState("");
  const [minutes, setMinutes] = useState("");
  const [seconds, setSeconds] = useState("");
  const [toHours, setTohours] = useState("");
  const [toMinutes, setToMinutes] = useState("");
  const [toSeconds, setToSeconds] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const [timeInputBox, setTimeInputBox] = useState(false);
  const [toTimeInputBox, setToTimeInputBox] = useState(false);
  const [opentotimePickerModal, setOpenToTimePickerModal] = useState(false);
  const [chargebackValue, setChargeBackValue] = useState(false);
  const [voucherServiceList, setVoucherServiceList] = useState([]);
  const [serviceType, setServiceType] = useState("");
  const [chargebackHold, setChargebackHold] = useState("");
  const [chargebackRelease, setChargeBackRelease] = useState("");
  const navigate = useNavigate();

  const inputStyle = {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#000000",
  };
  const containerStyle = {
    width: "258px",
    height: "55px",
    left: "calc(50% - 343px/2)",
    top: "24px",
    border: "1px solid #CBCACA",
    borderRadius: "6px",
    color: "#697D95",
    paddingLeft: "10px",
  };

  //from date and from time

  let fromDateformat = moment(fromDate).format("DD/MM/YYYY");

  let timevalueFrom = moment({
    hours: hours,
    minutes: minutes,
    seconds: seconds,
  }).format("HH.mm.ss");

  let fromDateWithFromTime = fromDateformat + ":" + timevalueFrom;

  //to date and to time
  let toDateWithformat = moment(toDate).format("DD/MM/YYYY");
  let timevalueTo = moment({
    hours: toHours,
    minutes: toMinutes,
    seconds: toSeconds,
  }).format("HH.mm.ss");
  let toDateWithToTime = toDateWithformat + ":" + timevalueTo;

  let dateRange = fromDateWithFromTime + "-" + toDateWithToTime;

  const fetchPayinDropDown = () => {
    ApiRequestGet.getAllServiceProviderList({
      type: "payin",
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          setPayinServiceList(modififyDropdownServiceNameList(res.data));
        }
      })
      .catch((err) => {});
  };

  const fetchVoucherDropDown = () => {
    ApiRequestGet.getAllServiceProviderList({
      type: "voucher",
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          setVoucherServiceList(modififyDropdownServiceNameList(res.data));
        }
      })
      .catch((err) => {});
  };
  const ServiceTypes = [
    {
      label: "Payin",
      value: "payin",
    },
    {
      label: "Voucher",
      value: "voucher",
    },
  ];

  const modifierClientData = (data) => {
    let newArr = [
      {
        label: "None",
        value: "",
      },
    ];
    let programValue;

    if (selectedServiceProvider?.value === "Fino") {
      data &&
        data?.clients?.map((val, i) => {
          programValue = (
            val?.programs?.find(
              (item) =>
                item.service_type === "payin" &&
                (item.mechanism === "vba" || item.mechanism === "qr")
            ) || {}
          ).program_id;

          newArr.push({
            label:
              val.firstName + " " + val.lastName + " / " + val.businessName,
            value: val?.userId,
            programId: programValue,
          });
        });
    } else {
      data &&
        data?.clients?.map((val, i) => {
          programValue = (
            val?.programs?.find((item) => item.service_type === "payin") || {}
          ).program_id;

          newArr.push({
            label:
              val.firstName + " " + val.lastName + " / " + val.businessName,
            value: val?.userId,
            programId: programValue,
          });
        });
    }

    return newArr;
  };
  const modifierClientData1 = (data) => {
    let newArr = [
      {
        label: "None",
        value: "",
      },
    ];
    let programValue;

    data &&
      data?.clients?.map((val, i) => {
        programValue = (
          val?.programs?.find(
            (item) =>
              item.service_type === "voucher" && item.mechanism === "coupon"
          ) || {}
        ).program_id;

        newArr.push({
          label: val.firstName + " " + val.lastName + " / " + val.businessName,
          value: val?.userId,
          programId: programValue,
        });
      });

    return newArr;
  };

  const fetchPayinClientList = () => {
    ApiRequestPost.getPayinClientList({
      serviceType: serviceType?.value,
      serviceProviderName: selectedServiceProvider?.value,
    })
      .then((res) => {
        console.log(res, "response");
        if (serviceType?.value === "payin") {
          setPayinClientList(modifierClientData(res?.data));
        }
      })
      .catch((err) => {});
  };
  const fetchVoucherClientList = () => {
    ApiRequestPost.getPayinClientList({
      serviceType: serviceType?.value,
      serviceProviderName: selectedServiceProvider?.value,
    })
      .then((res) => {
        if (serviceType?.value === "voucher") {
          setVoucherClientList(modifierClientData1(res?.data));
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    fetchPayinClientList();
    fetchVoucherClientList();
  }, [selectedServiceProvider]);
  useEffect(() => {
    fetchPayinDropDown();
    fetchVoucherDropDown();
  }, []);

  const createSettlement = () => {
    ApiGetServiceWrapper({
      headers: {
        client_id: selectedClient?.value,
        daterange: dateRange,
        servicetype: serviceType?.value,
        program_id: selectedClient?.programId,
        totalcommissionamount: comission,
        totalactualamount: actualAmount,
        totaltransferamount: transferAmount,
        totalcommissiongst: comissionGST,
        utr: bankUTR,
        reserves: rollbackReserves,
        serviceProviderName: selectedServiceProvider?.value,
        chargeback: chargebackValue,
        chargebackHold: chargebackHold,
        chargebackRelease: chargebackRelease,
      },
      url: API_ENDPOINT.core_url + "finance/settlement/record/create",
    })
      //.then((response) => response.json())
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(response.message, {
            variant: "success",
          });
          navigate("/finance");
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      });
  };

  useEffect(() => {
    console.log(payinClientList, "payin client list");
  }, [payinClientList]);

  useEffect(() => {
    console.log(voucherClientList, "voucher list");
  }, [voucherClientList]);
  return (
    <div
      style={{
        width: "100%",
        overflow: "auto",
        boxSizing: "border-box",
        backgroundColor: "white",
      }}
    >
      <MainComponent filterRequired={false} headerTitle="Client Settlement" />
      <div style={styles.filtersDiv}>
        <div style={{ margin: 10, width: "258px" }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Service Type
          </label>

          <CustomSelect
            value={serviceType}
            options={ServiceTypes}
            onChange={(data) => {
              setServiceType(data);
            }}
            placeholder={"Select service Type"}
          />
        </div>
        <div style={{ margin: 10, width: "258px" }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Service Provider
          </label>

          <CustomSelect
            disabled={serviceType === "" ? true : false}
            value={selectedServiceProvider}
            options={
              serviceType?.value === "payin"
                ? payinServiceList
                : serviceType?.value === "voucher"
                ? voucherServiceList
                : ""
            }
            onChange={(data) => {
              setSelectedServiceProvider(data);
            }}
            placeholder={"Select service provider"}
          />
        </div>
        <div style={{ margin: 10, width: "258px" }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Client
          </label>

          <CustomSelect
            placeholder={"Select client"}
            options={
              serviceType?.value === "payin"
                ? payinClientList
                : serviceType?.value === "voucher"
                ? voucherClientList
                : ""
            }
            value={selectedClient}
            onChange={(data) => {
              setSelectedClient(data);
            }}
          />
        </div>
        <div style={{ margin: 10 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            From
          </label>
          <CustomDatePicker
            value={fromDate}
            onChange={(data) => {
              setFromDate(data);
              setTimeInputBox(true);
              setOpenTimePickerModal(true);
            }}
          />
        </div>
        {timeInputBox && (
          <div style={{ margin: 10 }}>
            <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
              From Time
            </label>
            <CustomInput
              placeholder=""
              validator=""
              value={moment({
                hours: hours,
                minutes: minutes,
                seconds: seconds,
              }).format("HH:mm:ss")}
              onChange={() => {
                setOpenTimePickerModal(true);
              }}
              type="input"
              inputcomponentStyles={{ ...inputStyle }}
              inputStyles={{
                ...containerStyle,
              }}
              isRightIconRequired={true}
              rightIcon={
                <TimerClock
                  onClick={() => {
                    setOpenTimePickerModal(true);
                  }}
                  style={styles.iconStyle}
                />
              }
            />
          </div>
        )}
        <div style={{ margin: 10 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            To
          </label>
          <CustomDatePicker
            value={toDate}
            onChange={(data) => {
              setToDate(data);
              setOpenToTimePickerModal(true);
              setToTimeInputBox(true);
            }}
            minDate={fromDate}
            disabled={fromDate ? false : true}
          />
        </div>

        {toTimeInputBox && (
          <div style={{ margin: 10 }}>
            <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
              To Time
            </label>
            <CustomInput
              placeholder=""
              validator=""
              value={moment({
                hours: toHours,
                minutes: toMinutes,
                seconds: toSeconds,
              }).format("HH:mm:ss")}
              onChange={() => {
                setOpenToTimePickerModal(true);
              }}
              type="input"
              inputcomponentStyles={{ ...inputStyle }}
              inputStyles={{
                ...containerStyle,
              }}
              isRightIconRequired={true}
              rightIcon={
                <TimerClock
                  onClick={() => {
                    setOpenToTimePickerModal(true);
                  }}
                  style={styles.iconStyle}
                />
              }
            />
          </div>
        )}
        <div style={{ margin: 10 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Collected Amount
          </label>
          <CustomInput
            placeholder="Collected Amount"
            validator="amountSettlement"
            value={actualAmount}
            onChange={(data) => {
              setActualAmount(data);
            }}
            type="input"
            inputcomponentStyles={{ ...inputStyle }}
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>
        <div style={{ margin: 10 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Settled amount
          </label>
          <CustomInput
            placeholder="Settled amount"
            validator="amountSettlement"
            value={transferAmount}
            onChange={(data) => {
              setTransferAmount(data);
            }}
            type="input"
            inputcomponentStyles={{ ...inputStyle }}
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>
        <div style={{ margin: 10 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Comission
          </label>
          <CustomInput
            placeholder="Comission"
            validator="amountSettlement"
            value={comission}
            onChange={(data) => {
              setComission(data);
            }}
            type="input"
            inputcomponentStyles={{ ...inputStyle }}
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>
        <div style={{ margin: 10 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            ChargeBack Hold
          </label>
          <CustomInput
            placeholder="chargeback Hold"
            validator="amountSettlement"
            value={chargebackHold}
            onChange={(data) => {
              setChargebackHold(data);
            }}
            type="input"
            inputcomponentStyles={{ ...inputStyle }}
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>
        <div style={{ margin: 10 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            chargeback Release
          </label>
          <CustomInput
            placeholder="chargeback Release"
            validator="amountSettlement"
            value={chargebackRelease}
            onChange={(data) => {
              setChargeBackRelease(data);
            }}
            type="input"
            inputcomponentStyles={{ ...inputStyle }}
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>
        <div style={{ margin: 10 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Comission GST
          </label>
          <CustomInput
            placeholder="Comission GST"
            validator="amountSettlement"
            value={comissionGST}
            onChange={(data) => {
              setComissionGST(data);
            }}
            type="input"
            inputcomponentStyles={{ ...inputStyle }}
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>
        <div style={{ margin: 10 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Bank UTR
          </label>
          <CustomInput
            placeholder="Bank UTR"
            validator="alphaNum"
            value={bankUTR}
            onChange={(data) => {
              setBankUTR(data);
            }}
            type="input"
            inputcomponentStyles={{ ...inputStyle }}
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>
        <div style={{ margin: 10 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Roll back reserves
          </label>
          <CustomInput
            placeholder="Roll back reserves"
            validator="amountSettlement"
            value={rollbackReserves}
            onChange={(data) => {
              setRollbackReserves(data);
            }}
            type="input"
            inputcomponentStyles={{ ...inputStyle }}
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>
        <div style={{ margin: 10, marginTop: "30px" }}>
          <CheckBoxInput
            title="Chargeback"
            value="chargeback"
            onChange={() => {
              setChargeBackValue(true);
            }}
            textStyling={{
              fontSize: "16px",
              fontWeight: 600,
            }}
          />
        </div>
        <div>
          <CustomButton
            title="Proceed"
            styles={{
              background: "#38369C",
              margin: "10px",
              marginTop: "40px",
            }}
            textStyles={{
              color: "#FDFDFD",
              fontWeight: "500",
              fontSize: "16px",
            }}
            onClick={() => {
              if (
                selectedClient === "" ||
                comission === "" ||
                actualAmount === "" ||
                transferAmount === "" ||
                comissionGST === "" ||
                bankUTR === "" ||
                rollbackReserves === "" ||
                selectedServiceProvider?.value === "" ||
                fromDate === "" ||
                toDate === "" ||
                chargebackHold === "" ||
                chargebackRelease === ""
              ) {
                enqueueSnackbar("Please fill all fields", {
                  variant: "error",
                });
                return;
              }

              createSettlement();
            }}
          />
        </div>
      </div>
      {openTimePickerModal && (
        <CustomModal
          headerTitle="Select Time"
          open={openTimePickerModal}
          onClose={() => {
            setOpenTimePickerModal(false);
          }}
          containerStyle={styles.modalContainerStyle}
          isConfirmationModalRequired={true}
        >
          <CustomTimePicker
            onClickCancel={() => {
              setOpenTimePickerModal(false);
            }}
            onClickSave={(selectedHour, selectedMinute, selectedSecond) => {
              if (
                selectedHour === undefined ||
                selectedMinute === undefined ||
                selectedSecond === undefined
              ) {
                enqueueSnackbar("Please fill all fields", {
                  variant: "error",
                });
                return;
              }
              setHours(selectedHour);
              setMinutes(selectedMinute);
              setSeconds(selectedSecond);
              setOpenTimePickerModal(false);
            }}
          />
        </CustomModal>
      )}
      {opentotimePickerModal && (
        <CustomModal
          headerTitle="Select Time"
          open={opentotimePickerModal}
          onClose={() => {
            setOpenToTimePickerModal(false);
          }}
          containerStyle={styles.modalContainerStyle}
          isConfirmationModalRequired={true}
        >
          <CustomTimePicker
            onClickCancel={() => {
              setOpenToTimePickerModal(false);
            }}
            onClickSave={(selectedHour, selectedMinute, selectedSecond) => {
              if (
                selectedHour === undefined ||
                selectedMinute === undefined ||
                selectedSecond === undefined
              ) {
                enqueueSnackbar("Please fill all fields", {
                  variant: "error",
                });
                return;
              }

              if (fromDateformat === toDateWithformat) {
                if (selectedHour < hours) {
                  enqueueSnackbar("Please provide valid time", {
                    variant: "error",
                  });
                  return;
                }
              }

              setTohours(selectedHour);
              setToMinutes(selectedMinute);
              setToSeconds(selectedSecond);
              setOpenToTimePickerModal(false);
            }}
          />
        </CustomModal>
      )}
    </div>
  );
};

const styles = {
  filtersDiv: {
    display: "flex",
    flexWrap: "wrap",
    marginTop: "10px",
    marginLeft: "20px",
  },
  modalContainerStyle: {
    //minWidth: 350,
    maxWidth: 350,
    height: "auto",
    maxHeight: 800,
  },
  iconStyle: {
    height: 27,
    width: 30,
    cursor: "pointer",
  },
};

export default ClientSettlementIndex;
